'use strict';

const get = require('lodash/get');

const async = require('async');

const BrowserHistoryHandler = require('../../browser_history_handler/frontend/browser_history_handler');

const CrossSellBait = require('../../cross_sell_bait/frontend/cross_sell_bait');

const OffersMapCategoryFilters = require('../../offers_map_category_filters/frontend/offers_map_category_filters');

const OffersMapFilters = require('../../offers_map_filters/frontend/offers_map_filters');

const CurrentLocation = require('./current_location');

const MarkerTooltip = require('./marker_tooltip');

const PlaceCard = require('./place_card');

const initializeRichMarker = require('./vendor/richmarker-compiled.js');

const MOBILE_WEB_PINS_TO_SHOW_ON_MAP = 5;

module.exports = (function () {
  class OffersMap {
    static initClass() {
      this.prototype.templates = {
        main: require('../main.html.mustache'),
        mapMarker: require('../map_marker.html.mustache'),
        goFullscreen: require('../go_fullscreen.html.mustache'),
        tooltip: require('../tooltip.html.mustache'),
        noPlacesFound: require('../no_places_found.html.mustache'),
      };
    }

    constructor({ el, place, config, $mobileWrapper, $desktopWrapper }) {
      this.historyHandler = this.historyHandler.bind(this);
      this.resize = this.resize.bind(this);
      this.moveWidget = this.moveWidget.bind(this);
      this.scrollHandler = this.scrollHandler.bind(this);
      this.clearFilters = this.clearFilters.bind(this);
      this.el = el;
      this.place = place;
      this.config = config;
      this.$mobileWrapper = $mobileWrapper;
      this.$desktopWrapper = $desktopWrapper;
      this.$el = $(this.el);
      this.cache = {};
      this.cards = [];
      this.rootUrl = '/merchant-page/offers-map';
      this.disableMapListeners = false;
      this.loadingCount = 0;
      this.history = new BrowserHistoryHandler('offers-map');
      this.history.onPop(this.historyHandler);
      this.render();
      this.$offersMap = this.$el.find('.offers-map');
      this.$cards = this.$el.find('.place-cards');
      this.$cardsOverflow = this.$el.find('.place-cards-overflow');
      this.$showingPlaces = this.$el.find('.showing-x-places-long');
      this.$showingPlacesShort = this.$el.find('.showing-x-places-short');
      this.$partialLoading = this.$el.find('.partial-loading-overlay');
      this.$fullLoading = this.$el.find('.full-loading-overlay');
      this.$searchWhenMapMoves = this.$el.find('.search-when-map-moves input');
      this.$noPlacesFound = this.$el.find('.no-places-found');
      this.$viewAllPlaces = this.$el.find('.view-all-places');
      this.$redoSearch = this.$el.find('.redo-search-in-this-area');
      this.$filterCount = this.$el.find('.filter-count');
      this.bindings();
      this.setBaseTarget();
      this.moveWidgetInit();
      this.loadMapOnResize();
      this.init();
    }

    bindings() {
      this.bindFullscreenHandler();
      this.$el.find('.filter-button').click(() => {
        if (!this.$offersMap.hasClass('fullscreen')) {
          this.fullscreenHandler();
        }

        return this.filters.showMobileModal();
      });
      this.$el.find('.map-button').click(() => {
        if (this.$offersMap.hasClass('show-phone-map')) {
          this.$offersMap.removeClass('show-phone-map');
        } else {
          if (!this.$offersMap.hasClass('fullscreen')) {
            this.fullscreenHandler();
          }

          this.$offersMap.addClass('show-phone-map');
        }

        return this.resize();
      });
      this.$redoSearch.click(() => {
        return this.fetchAndUpdatePlacesForMapInView();
      });
      this.currentLocation = new CurrentLocation({
        $el: this.$el.find('.show-current-location'),
        $error: this.$el.find('.show-current-location-error-box'),
      });
      return null;
    }

    historyHandler({ action, placeId }) {
      if (this.config.fullscreenOnly !== true) {
        if (action == null && this.$offersMap.hasClass('fullscreen')) {
          this.fullscreenHandler(false);

          if (this.placePreviewDrawer != null) {
            this.placePreviewDrawer.hide(false);
          }

          this.placePreviewDrawer = null;
          return this.placePreviewDrawer;
        } else if (action === 'enter-fullscreen') {
          return this.fullscreenHandler(false);
        } else if (action === 'exit-fullscreen') {
          this.fullscreenHandler(false);

          if (this.placePreviewDrawer != null) {
            this.placePreviewDrawer.hide(false);
          }

          this.placePreviewDrawer = null;
          return this.placePreviewDrawer;
        } else if (action === 'place-preview-hide-modal') {
          if (this.placePreviewDrawer != null) {
            this.placePreviewDrawer.hide(false);
          }

          this.placePreviewDrawer = null;
          return this.placePreviewDrawer;
        }
      } else if (action === 'place-preview-show-modal') {
        return (() => {
          const result = [];

          for (const card of this.cards) {
            if (card.place.uuid === placeId) {
              card.showPreviewFromHistory();
              break;
            } else {
              result.push(undefined);
            }
          }

          return result;
        })();
      } else if (action === 'place-preview-hide-modal') {
        return (() => {
          const result1 = [];

          for (const card of this.cards) {
            if (card.place.uuid === placeId) {
              card.hidePreview(false);
              break;
            } else {
              result1.push(undefined);
            }
          }

          return result1;
        })();
      } else if (action == null) {
        return (() => {
          const result2 = [];

          for (const card of this.cards) {
            if (card.isPlacePreviewShowingThisPlace()) {
              card.hidePreview(false);
              break;
            } else {
              result2.push(undefined);
            }
          }

          return result2;
        })();
      }
      return null;
    }

    isDesktopView() {
      return Modernizr.mq('(min-width: 768px)');
    }

    setBaseTarget() {
      // Open links on a separate window when the map is being rendered on /maps
      if (this.config.fullscreenOnly === true) {
        return $('head').append('<base target="_blank" />');
      }
      return null;
    }

    updatePlaceCardsWidth() {
      // This logic is necessary for the mobile web horizontal scrolling.
      if (!this.isDesktopView() && this.$offersMap.hasClass('show-phone-map')) {
        const $placeCard = this.$cards.find('.place-card');

        if ($placeCard.length > 0) {
          const width = $placeCard.length * $placeCard.outerWidth();
          return this.$cards.css('width', `${width}px`);
        }
      } else {
        return this.$cards.removeAttr('style');
      }
      return null;
    }

    resize() {
      this.updatePlaceCardsWidth();

      if (!this.isMapVisible()) {
        return null;
      }

      if (this.map != null) {
        google.maps.event.trigger(this.map, 'resize');
        return setTimeout(() => this.zoomToShowAllMarkers(), 500);
      } else {
        this.loadGoogleMaps(err => {
          if (err) {
            throw err;
          }

          this.createMap();
          this.renderPlaces();
          return this.mapLoaded();
        });
        return null;
      }
    }

    loadMapOnResize() {
      let debounceTimeout = null;
      return $(window).on('resize', () => {
        if (debounceTimeout != null) {
          clearTimeout(debounceTimeout);
        }

        debounceTimeout = setTimeout(this.resize, 300);
        return debounceTimeout;
      });
    }

    moveWidgetInit() {
      if (
        !(
          (this.$mobileWrapper != null
            ? this.$mobileWrapper.length
            : undefined) > 0
        )
      ) {
        return;
      }

      let debounceTimeout = null;
      $(window).on('resize', () => {
        if (debounceTimeout != null) {
          clearTimeout(debounceTimeout);
        }

        debounceTimeout = setTimeout(this.moveWidget, 250);
        return debounceTimeout;
      });
      return void this.moveWidget();
    }

    moveWidget() {
      // On Mobile, when the place has no offers, we move the Offes Map widget to the top.
      if (this.isDesktopView()) {
        if (this.$desktopWrapper.find(this.$el).length !== 0) {
          return null;
        }

        this.$desktopWrapper.html(this.$el);
        return this.$mobileWrapper.find(this.$el).remove();
      } else {
        if (this.$mobileWrapper.find(this.$el).length !== 0) {
          return null;
        }

        this.$mobileWrapper.html(this.$el);
        return this.$desktopWrapper.find(this.$el).remove();
      }
    }

    isMapVisible() {
      // The second part is to avoid trying to load the Google Maps API when running
      // on a forbidden domain (or localhost, for running tests).
      return (
        (this.isDesktopView() || this.$offersMap.hasClass('show-phone-map')) &&
        /(^|\.)groupon(\.)/.test(window.location.host)
      );
    }

    render() {
      const data = {};

      data.translate = data.t = () => str => I18n.t(str);

      const goFullscreenHtml = this.templates.goFullscreen.render(data);
      this.$el.html(
        this.templates.main.render(
          _.extend(data, {
            goFullscreenHtml,
            config: this.config,
          })
        )
      );
      this.filters = new OffersMapFilters({
        el: this.$el.find('.offers-map-filters-wrapper'),
        config: this.config,
        history: this.history,
      });
      this.filters.onChange(() => {
        this.renderPlaces();
        return this.updateFilterCount();
      });
      this.categoryFilters = new OffersMapCategoryFilters({
        el: this.$el.find('.offers-map-category-filters-wrapper'),
      });
      this.categoryFilters.onChange(() =>
        this.fetchAndUpdatePlacesForMapInView()
      );
      return this.$el;
    }

    init() {
      async.auto(
        {
          getPlaces: [
            'getLocation',
            (done, results) => {
              let data;
              const currentPosition =
                results != null ? results.getLocation : undefined;

              if (
                (currentPosition != null ? currentPosition.lat : undefined) !=
                  null &&
                (currentPosition != null ? currentPosition.lon : undefined) !=
                  null
              ) {
                data = currentPosition;
              } else {
                data = {
                  lat: this.place.lat,
                  lon: this.place.lon,
                };
              } // When setting dynamic_radius=true, the server will increase the radius if there are
              // not enough places in the given radius.

              if (this.config.dynamicRadius === true) {
                data.dynamic_radius = true;
              }

              this.fetchPlaces(data, (err, res) => {
                // Ignore errors, so that the "getGoogleMaps" task can finish.
                done(null, res);
              });
            },
          ],
          getGoogleMaps: done => {
            if (!this.isMapVisible()) {
              done();
              return;
            }

            this.loadGoogleMaps(err => {
              // TODO: gracefully handle error
              if (err) {
                throw err;
              }

              done();
            });
          },
        },
        (err, { getPlaces }) => {
          if (this.isMapVisible()) {
            this.createMap();
          }

          this.bindScrollHandler();
          this.places = getPlaces != null ? getPlaces.places : undefined;
          this.renderPlaces();

          if (this.map != null) {
            this.mapLoaded();
          }

          if ((this.places != null ? this.places.length : undefined) > 0) {
            if (this.config.showBait === true && this.isDesktopView()) {
              setTimeout(() => this.showBait(), 1000);
            }
          } else {
            this.noPlacesFound();
          }

          return this.$fullLoading.addClass('hidden');
        }
      );
    }

    loadGoogleMaps(cb) {
      Groupon.Utils.GoogleMaps.load(err => {
        if (err) {
          cb(err);
          return;
        } // This needs to be called once window.google.maps is available.

        initializeRichMarker();
        cb();
      });
    }

    mapLoaded() {
      if ((this.places != null ? this.places.length : undefined) > 0) {
        this.zoomToShowAllMarkers();
      }

      this.addMapListeners();
      return this.addStarMarker();
    }

    removeAllMarkers() {
      for (const card of this.cards) {
        card.destroy();
      }

      this.cards = [];
      return this.cards;
    }

    shouldHidePlaceCard(card, filters) {
      return (
        (filters.deals && !card.hasDeals()) ||
        filters.onlineOrdering ||
        (filters.openNow && !card.isOpenNow())
      );
    }

    renderPlaces() {
      this.$noPlacesFound.addClass('hidden');
      this.removeAllMarkers();

      if (this.placePreviewDrawer != null) {
        this.placePreviewDrawer.hide();
      }

      const $placePreview = this.$el.find('.place-preview-container');

      if ((this.places != null ? this.places.length : undefined) > 0) {
        let card;
        let i;
        let asc;
        let end;
        const filters = this.filters.values();

        if (filters.sortBy === 'distance') {
          this.sortByDistance();
        } else if (filters.sortBy === 'rating') {
          this.sortByRating();
        } else {
          this.sortByRelevance();
        }

        let label = 0;

        for (
          i = 0, end = this.places.length, asc = 0 <= end;
          asc ? i < end : i > end;
          asc ? i++ : i--
        ) {
          label += 1;
          card = new PlaceCard({
            offersMap: this,
            place: this.places[i],
            label,
            map: this.map,
            $placePreview,
            config: this.config,
            history: this.history,
          });

          if (this.shouldHidePlaceCard(card, filters)) {
            card.destroy();
            label -= 1;
            continue;
          }

          this.cards.push(card);
          this.$cards.append(card.render());
        }

        if (this.cards.length > 0) {
          let asc1;
          let start;

          for (
            start = this.cards.length - 1, i = start, asc1 = start <= 0;
            asc1 ? i <= 0 : i >= 0;
            asc1 ? i++ : i--
          ) {
            // We do this in reverse so that pin #1 shows up on top of pin #2 without having
            // to mess around with z-indexes.
            card = this.cards[i];
            card.addMarker();
          }
        }
      }

      this.$cards.scrollTo({
        left: 0,
        top: 0,
      });
      this.$cardsOverflow.scrollTo({
        left: 0,
        top: 0,
      });
      this.scrollHandler();

      if (this.$cards.find('.place-card').length === 0) {
        this.noPlacesFound();
        this.$viewAllPlaces.addClass('hidden');
      } else {
        this.$viewAllPlaces.removeClass('hidden');
      }

      this.updateNumberOfPlaces();
      return this.updatePlaceCardsWidth();
    }

    fullscreenHandler(saveInHistory = true) {
      if (this.$offersMap.hasClass('fullscreen')) {
        $('body').removeClass('modal-open');
        this.$offersMap.removeClass('show-phone-map');
        this.$offersMap.removeClass('fullscreen');

        if (this.map != null) {
          this.map.setOptions({
            scrollwheel: false,
          });
        }

        if (saveInHistory) {
          this.history.add({
            action: 'exit-fullscreen',
          });
        }
      } else {
        $('body').addClass('modal-open');
        this.$offersMap.addClass('fullscreen');

        if (this.map != null) {
          this.map.setOptions({
            scrollwheel: true,
          });
        }

        if (saveInHistory) {
          this.history.add({
            action: 'enter-fullscreen',
          });
        }
      }

      if (this.map != null) {
        google.maps.event.trigger(this.map, 'resize');
        return setTimeout(() => this.zoomToShowAllMarkers(), 500);
      }
      return null;
    }

    bindFullscreenHandler() {
      return this.$el
        .find('.go-fullscreen, .view-all-places, .go-back')
        .click(() => this.fullscreenHandler());
    }

    bindScrollHandler() {
      let debounce = null;
      return this.$cards.add(this.$cardsOverflow).scroll(() => {
        if (debounce != null) {
          clearTimeout(debounce);
        }

        debounce = setTimeout(this.scrollHandler, 5);
        return debounce;
      });
    }

    updateFilterCount() {
      const { count } = this.filters.values();
      this.$filterCount.text(count);

      if (count > 0) {
        return this.$filterCount.addClass('show');
      } else {
        return this.$filterCount.removeClass('show');
      }
    }

    numberOfPinsToShowOnMap() {
      if (this.isUsingHorizontalScrolling()) {
        return MOBILE_WEB_PINS_TO_SHOW_ON_MAP;
      } else {
        const cardHeight = this.$cards
          .find('.place-card:first-child')
          .outerHeight();
        return Math.floor(this.$cards.outerHeight() / cardHeight);
      }
    }

    isUsingHorizontalScrolling() {
      return (
        !this.isDesktopView() && this.$offersMap.hasClass('show-phone-map')
      );
    }

    scrollHandler() {
      let firstCardInView;
      let pixelsScrolled;
      let pinsToShowOnMap;

      if (!(this.$cards.find('.place-card').length > 0)) {
        return null;
      }

      if (this.map != null) {
        this.$el.find('.marker-label').removeClass('active');
      }

      if (this.isUsingHorizontalScrolling()) {
        pixelsScrolled = -this.$cards.position().left;
        const cardWidth = this.$cards
          .find('.place-card:first-child')
          .outerWidth();
        firstCardInView =
          Math.ceil((pixelsScrolled - (cardWidth * 2) / 3) / cardWidth) + 1;
        pinsToShowOnMap = this.numberOfPinsToShowOnMap();
      } else {
        pixelsScrolled = -this.$cards.find('.place-card:first-child').position()
          .top;
        const cardHeight = this.$cards
          .find('.place-card:first-child')
          .outerHeight();
        firstCardInView = Math.ceil(pixelsScrolled / cardHeight) + 1;
        pinsToShowOnMap = this.numberOfPinsToShowOnMap();
      }

      let count = 0;
      return (() => {
        const result = [];

        for (const card of this.cards) {
          count += 1;

          if (card.marker != null) {
            if (
              count >= firstCardInView &&
              count < firstCardInView + pinsToShowOnMap
            ) {
              card.showPin();
            } else {
              card.showDot();
            }
          } // Load images for cards that are in view now and the ones that will be in view soon.

          if (
            count >= firstCardInView - 2 &&
            count <= firstCardInView + pinsToShowOnMap + 2
          ) {
            result.push(card.showImage());
          } else {
            result.push(undefined);
          }
        }

        return result;
      })();
    }

    updateNumberOfPlaces() {
      let html;
      let htmlShort;
      const data = {
        highlightOpen: '<strong>',
        highlightClose: '</strong>',
        count: this.$cards.find('.place-card').length,
        placeName: this.place.name,
      };

      if (this.place.name != null) {
        html = I18n.t(
          'js.modules.offers_map.showing_x_places_near_place',
          data
        );
        htmlShort = I18n.t(
          'js.modules.offers_map.showing_x_places_near_place_short',
          data
        );
      } else {
        html = I18n.t('js.modules.offers_map.showing_x_places', data);
        htmlShort = I18n.t(
          'js.modules.offers_map.showing_x_places_short',
          data
        );
      }

      this.$showingPlaces.html(html);
      return this.$showingPlacesShort.html(htmlShort);
    }

    sortByRating() {
      function getRating(place) {
        const recommendation =
          place.ugc != null ? place.ugc.recommendation : undefined;

        if (recommendation != null ? recommendation.showToUser : undefined) {
          return recommendation.percentage;
        } else {
          return 0;
        }
      }

      return this.places.sort((a, b) => getRating(b) - getRating(a));
    }

    sortByDistance() {
      return this.places.sort((a, b) => a.distance.value - b.distance.value);
    }

    sortByRelevance() {
      return this.places.sort((a, b) => a.relevanceOrder - b.relevanceOrder);
    }

    fetchPlaces(data, cb) {
      data.limit = this.isDesktopView()
        ? this.config.limit.desktop
        : this.config.limit.mobile;
      const cacheKey = JSON.stringify(data);

      if (this.cache[cacheKey] != null) {
        cb(null, this.cache[cacheKey]);
        return;
      }

      $.ajax({
        url: `${this.rootUrl}/places`,
        type: 'GET',
        contentType: 'application/json',
        dataType: 'json',
        data,
        success: res => {
          if ((res != null ? res.result : undefined) !== 'ok') {
            cb(new Error(get(res, 'error.code', undefined)));
            return;
          } // Store the original order, so that we can reset it if a filter is applied later.

          if (get(res, 'data.places', '') > 0) {
            for (
              let i = 0, end = res.data.places.length, asc = 0 <= end;
              asc ? i < end : i > end;
              asc ? i++ : i--
            ) {
              res.data.places[i].relevanceOrder = i;
            }
          }

          this.cache[cacheKey] = res.data;
          cb(null, res.data);
        },

        error() {
          cb(new Error('Request Failed'));
        },
      });
    }

    zoomToShowAllMarkers() {
      if (this.map == null || !(this.cards.length > 0)) {
        return;
      }

      const bounds = new google.maps.LatLngBounds();

      for (const placeCard of this.cards) {
        bounds.extend(placeCard.marker.getPosition());
      } // We disable the map listeners while adjusting the zoom to avoid triggering a new fetch.

      this.disableMapListeners = true;
      this.map.fitBounds(bounds);
      return void setTimeout(() => {
        this.disableMapListeners = false;
        return this.disableMapListeners;
      }, 1000);
    }

    createMap() {
      let center;
      const coords = this.currentLocation.get();

      if (coords != null) {
        center = new google.maps.LatLng(coords.lat, coords.lon);
      } else {
        center = new google.maps.LatLng(this.place.lat, this.place.lon);
      }

      const options = {
        zoom: 13,
        center,
        mapTypeControl: false,
        draggable: true,
        scrollwheel: this.$offersMap.hasClass('fullscreen'),
        disableDefaultUI: true,
        zoomControl: true,
        zoomControlOptions: {
          style: google.maps.ZoomControlStyle.SMALL,
          position: google.maps.ControlPosition.LEFT_TOP,
        },
        mapTypeControlOptions: {
          mapTypeIds: [
            google.maps.MapTypeId.ROADMAP,
            google.maps.MapTypeId.SATELLITE,
          ],
          position: google.maps.ControlPosition.RIGHT_TOP,
        },
        streetViewControl: false,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.LEFT_BOTTOM,
        },
        styles: [
          {
            featureType: 'poi',
            stylers: [
              {
                visibility: 'off',
              },
            ], // Disable Google's "Points of Interest"
          },
          {
            featureType: 'transit.station.bus',
            stylers: [
              {
                visibility: 'off',
              },
            ], // Disable bus stops
          },
        ],
      };
      this.map = new google.maps.Map(
        this.$el.find('.map-container')[0],
        options
      );
      this.currentLocation.setMap(this.map);
      this.currentLocation.onNewLocation(err => {
        if (err) {
          return;
        }

        return void this.fetchAndUpdatePlacesForMapInView();
      });
    }

    addMapListeners() {
      this.map.addListener('dragend', () => {
        if (this.disableMapListeners) {
          return null;
        }

        if (this.isDesktopView() && this.$searchWhenMapMoves.is(':checked')) {
          return this.fetchAndUpdatePlacesForMapInView();
        } else {
          return this.$redoSearch.removeClass('hidden');
        }
      });
      let debounce = null;
      return this.map.addListener('zoom_changed', () => {
        if (this.disableMapListeners) {
          return null;
        }

        if (this.isDesktopView() && this.$searchWhenMapMoves.is(':checked')) {
          if (debounce != null) {
            clearTimeout(debounce);
          }

          debounce = setTimeout(() => {
            return this.fetchAndUpdatePlacesForMapInView();
          }, 250);
          return debounce;
        } else {
          return this.$redoSearch.removeClass('hidden');
        }
      });
    }

    fetchAndUpdatePlacesForMapInView() {
      let data;
      this.showLoading();
      this.$redoSearch.addClass('hidden');
      const categoryId = this.categoryFilters.value();

      if (this.map != null && this.isMapVisible()) {
        data = {
          lat: this.map.getCenter().lat(),
          lon: this.map.getCenter().lng(),
          radius: this.calculateRadiusInMeters(),
        };
      } else {
        data = {
          lat: this.place.lat,
          lon: this.place.lon,
        };
      }

      if (categoryId != null) {
        data.categories = categoryId;
      } // This is in case requests arrive in the wrong order.

      this.loadingCount += 1;
      const { loadingCount } = this;
      this.fetchPlaces(data, (err, fetchData) => {
        if (loadingCount !== this.loadingCount) {
          return;
        }

        this.places = fetchData != null ? fetchData.places : undefined;
        this.renderPlaces();
        return void this.hideLoading();
      });
    }

    calculateRadiusInMeters() {
      // We can't use the distance to one of the corners because the map might be a rectangle.
      // Instead, we need to calculate the minimun distance from the center to the north or the center to the east.
      const bounds = this.map.getBounds();
      const center = bounds.getCenter();
      const northEast = bounds.getNorthEast();
      const east = new google.maps.LatLng(center.lat(), northEast.lng());
      const north = new google.maps.LatLng(northEast.lat(), center.lng());
      const distanceFromCenterToNorth = google.maps.geometry.spherical.computeDistanceBetween(
        center,
        north
      );
      const distanceFromCenterToEast = google.maps.geometry.spherical.computeDistanceBetween(
        center,
        east
      );
      return Math.floor(
        Math.min(distanceFromCenterToEast, distanceFromCenterToNorth)
      );
    }

    clearFilters() {
      this.filters.clear();
      return this.categoryFilters.clear();
    }

    noPlacesFound() {
      let message;
      const filters = this.filters.values();
      const categoryFilter = this.categoryFilters.value();
      const lineBreak = '<span class="line-break"></span>';

      if (
        categoryFilter != null ||
        filters.deal ||
        filters.onlineOrdering ||
        filters.openNow
      ) {
        message = I18n.t('js.modules.offers_map.no_places_found.with_filters', {
          clearLinkOpen: '<span class="clear-filters">',
          clearLinkClose: '</span>',
          lineBreak,
        });
      } else {
        message = I18n.t(
          'js.modules.offers_map.no_places_found.without_filters',
          {
            lineBreak,
          }
        );
      }

      this.$noPlacesFound.html(
        this.templates.noPlacesFound.render({
          message,
        })
      );
      this.$noPlacesFound.removeClass('hidden');
      return this.$noPlacesFound
        .find('.clear-filters')
        .click(this.clearFilters);
    }

    getTooltipRecommendationsString() {
      if (
        !(
          (this.place.recommendations != null
            ? this.place.recommendations.total
            : undefined) > 0
        )
      ) {
        return null;
      }

      const { total, percentage } = this.place.recommendations;
      return I18n.t('js.modules.offers_map.place_card.recommendations', {
        total,
        percentage,
      });
    }

    addStarMarker() {
      if (this.place.showMarker === false) {
        return;
      }

      const tooltipData = {
        isMainMarker: true,
        name: this.place.name,
        mainCategory:
          this.place.category != null
            ? this.place.category.singular
            : undefined,
        formattedLocation:
          this.place.streetAddress != null
            ? this.place.streetAddress.replace(/\.$/, '')
            : undefined,
        translations: {
          recommendations: this.getTooltipRecommendationsString(),
        },
      };
      const data = {
        label: '<span class="icon-star-filled"></span>',
        tooltipHtml: this.templates.tooltip.render(tooltipData),
      };
      const $marker = $(this.templates.mapMarker.render(data));
      $marker.find('.marker-label').addClass('default-cursor');
      const $tooltip = $marker.find('.marker-tooltip');
      this.marker = new RichMarker({
        position: new google.maps.LatLng(this.place.lat, this.place.lon),
        map: this.map,
        draggable: false,
        shadow: false,
        content: $marker[0],
      });
      this.tooltip = new MarkerTooltip({
        marker: this.marker,
        $hoverElement: $marker.find('.marker-label'),
        $mapContainer: this.$el.find('.map-container'),
        $tooltip,
        $marker,
      }); // This is necessary so that we only calculate the tooltip position after the map and marker are loaded

      return void setTimeout(() => this.tooltip.show(), 1000);
    }

    showLoading() {
      return this.$partialLoading.removeClass('hidden');
    }

    hideLoading() {
      return this.$partialLoading.addClass('hidden');
    }

    showBait() {
      return new CrossSellBait({
        $offers: this.$el,
      });
    }

    removeAllPlaceCardHighlights() {
      return this.cards.map(card => card.removeHighlight());
    }
  }
  OffersMap.initClass();
  return OffersMap;
})();
